export default __webpack_public_path__ + "static/media/02.b35f0211.webp";